<template>
    <div class="vin-wrapper" :class="addToCart && 'mb-2'">
        <slot name="title" />
        <div class="w-full pt-4" id="vin-tool">
            <loading-overlay :active.sync="displayLoader" id="loader" loader="dots" color="#1A74DB" height="30" width="100%" opacity="0.85">
                <template v-slot:after>
                    <h3 id="loading-notice"> {{ webstoreContent.selectProductsPage.getting_cables }} </h3>
                </template>
            </loading-overlay>
            <TextAreaLineNumbers
                :value="currentVinValue"    
                placeholderNumbers="1
2"
                placeholder="ABCDE1234567890
ABCDE1234567891"
                @key-up="keyUp"

            ></TextAreaLineNumbers>
            <div v-if="!addToCart" class="flex justify-center items-center flex-wrap">
                <v-button
                    position="right"
                    mobile="12"
                    tablet="12"
                    desktop="12"
                    styling="secondary rounded"
                    :disabled="disabled || disabledDone"
                    @onClickEvent="submitVinData">
                    <template v-slot:content>
                        {{ submitCablesText }}
                    </template>
                </v-button>
            </div>
        </div>
    </div>
</template>

<script>
    import vButton from '../utils/button';
    import CableSelectionValidations from '../../mixins/cable-selection-validation'
    import TextAreaLineNumbers from './text-area-line-numbers.vue';
    import { WebstoreResources } from '../../mixins/webstore-resources';

    export default {

        mixins: [CableSelectionValidations, WebstoreResources],

        components: {vButton, TextAreaLineNumbers},

        props: {
            cableSkuToNames: {
                required: false,
                default: {},
            },
            isCableAccessoriesPage: {
                required: false,
                default: false
            },
            addToCart: {
                type: Boolean,
                default: false,
            },
            selectedTypeOfReplacementCable: {
                required: false,
                default: 'B series'
            }
        },

        data() {
            return {
                displayLoader: false,
                disabled: true,
                currentVinValue: '',
                hasChanged: false,
            }
        },

        computed: {

            vinData() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/vin/vinData`];
            },

            submitCablesText() {
                let isOfferInCart = this.productsInCart.find(offerInCart => offerInCart.productKey === this.activeProductKey && offerInCart.offerKey === this.activeOfferKey);
                return isOfferInCart ? this.webstoreContent.selectProductsPage.update_selection : this.webstoreContent.selectProductsPage.confirm_cable_selection;
            },
            
            totalCablesSubmittedData() {
                return this.$store.getters[
                    `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/totalCablesSubmittedData`
                ];
            },

            disabledDone() {
                this.cablesNeededCount === this.totalCablesSubmittedCount ? true : false;
            }
        },

        methods: {
            setVinData(event) {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/vin/setVinData`, event.target.value);
            },

            setCableSelectionMessage(message) {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/setCableSelectionMessage`, message);
            },

            setCableSelectionMessageType(type) {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/setCableSelectionMessageType`, type);
            },

            keyUp(event) {
                this.disabled = !(event.target.value.length > 0);
                this.currentVinValue = event.target.value;
                this.hasChanged = true;
                this.setVinData(event);
            },

            clearVisualData() {
                if (this.isCableAccessoriesPage) {
                    window.scrollTo({
                    left: 0,
                    top: 0,
                    behavior: 'smooth',
                    });
                }
                this.disabled = true;
                this.setCableSelectionMessage('');
                this.currentVinValue = '';
                this.clearSubmittedVinData();
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/vin/setVinData`);
            },

            clearSubmittedVinData() {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/vin/clearSubmittedVinData`);
            },

            verifyVinData() {
                let splitVins = this.vinData.split('\n');
                // Remove potential trailing commas and spaces
                splitVins = splitVins.map(vin => vin.replace(/,\s*$/, "").replace(" ", "")).filter(vin => vin);
                let correctVins = splitVins.filter(vin => vin.length === 17).length;
                if (splitVins.length === 1 && splitVins[0].length !== 17) {
                    this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.vin_error_length.replace('_length_', splitVins[0].length));
                    this.setCableSelectionMessageType('general')
                    return false;
                } else if (splitVins.length !== correctVins) {
                    this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.vin_error_length_multiple.replace('_length_', splitVins.length - correctVins));
                    this.setCableSelectionMessageType('general')
                    return false;
                }
                return true;
            },

            submitVinData: async function() {
                // Don't rerun unless we update the vin
                if (!this.hasChanged) {
                    return true
                }

                this.hasChanged = false;

                if (!this.vinData) {
                    this.clearSubmittedVinData();
                    return true;
                }

                this.clearSubmittedVinData();

                if (!this.isCableAccessoriesPage && this.calculateMaxCableSubmissionQuantity("vin") > this.cablesNeededCount - this.cablesSelectedCount) {
                    this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.vin_error_amount.replace('_length_', this.cablesNeededCount - this.cablesSelectedCount));
                    this.setCableSelectionMessageType('general')
                    return false;
                }

                // Prevent more selections than possible

                if (!this.verifyVinData()) {
                    return false;
                }
                let errorCables = [];
                let outOfStockCables = [];
                try {
                    this.displayLoader = true;
                    const cablesWithIssues = await this.$store.dispatch(`${this.activeProductKey}${this.activeOfferKey}CableSelection/vin/submitVinData`, this.selectedTypeOfReplacementCable);
                    errorCables = cablesWithIssues.errorCables;
                    outOfStockCables = cablesWithIssues.outOfStockCables;
                    this.displayLoader = false;
                    this.setCableSelectionMessage('');
                } catch(e) {
                    this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.cable_error_retry);
                    this.setCableSelectionMessageType('general')
                    this.displayLoader = false;
                    return false;
                }

                this.hasChanged = false;

                let foundErrors = [];
                errorCables.forEach(error => {
                    foundErrors.push(error.originalPayload);
                });

                if (errorCables.length > 0 && (this.submittedVinData.length + errorCables.length === 1)) {
                    this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.cannot_find_vin);
                    this.setCableSelectionMessageType('general')
                } else if (errorCables.length > 0) {
                    this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.cannot_find_vins.replace('_vins_', foundErrors.join(', ')));
                    this.setCableSelectionMessageType('specific')
                }
                if (outOfStockCables.length > 0) {
                    const cablesSkusOufOfStock = outOfStockCables.map(cables=>cables.cable).join(', ');
                    const vinsUsedForOutOfStock = outOfStockCables.map(cables=>cables.originalPayload).join(', ')
                     this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.out_of_stock_cables.replace('<cables>', cablesSkusOufOfStock).replace('<vins/mmys>',vinsUsedForOutOfStock));
                 }
                return true;
            },
        },
        created() {
            this.unsubscribe = this.$store.subscribe((mutation) => {
                if (
                    [`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/clearTotalCablesSubmittedData`,
                    `${this.activeProductKey}${this.activeOfferKey}CableSelection/vin/clearVinData`
                    ].includes(mutation.type)
                ) {
                    this.clearVisualData();
                }
            });
        },
    }
</script>

<style scoped>

    #vin-tool {
        height: auto;
        width: 100%;
        font-family: "Nitti Grotesk", sans-serif;
        font-style: normal;
        font-weight: normal;
        line-height: 30px;
        margin-top: 10px;
        padding: 0;
    }

    @media (min-width: 736px) {
        .vin-wrapper {
            padding-right: 20px;
        }
    }

    .flex {
        width: 100%;
        display: flex;
    }

    .flex-end {
        justify-content: flex-end;
    }

    #header {
        font-size: 24px;
        color: #474F54;
    }

    #loading-notice {
        text-align: center;
    }

    .clear {
        font-size: 20px;
        line-height: 28px;
        color: #0D6EDE;
        margin-right: 40px;
        font-weight: bold;
        cursor: pointer;
        height: fit-content;
    }

    .disabled {
        opacity: 0.4;
    }

</style>
